module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/pagetitre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/ident1#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Figures")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 - Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-002"
    }
  }, [_vm._v("Industry Segments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-003"
    }
  }, [_vm._v("Natural Gas Act of 1938")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-004"
    }
  }, [_vm._v("The Phillips Decision")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-005"
    }
  }, [_vm._v("Natural Gas Policy Act of 1978")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-006"
    }
  }, [_vm._v("Orders 436 and 500")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-007"
    }
  }, [_vm._v("Mega-NOPR")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("2 - The Physical (Cash) Market for Natural Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-008"
    }
  }, [_vm._v("Business Activity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-009"
    }
  }, [_vm._v("Supply")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-010"
    }
  }, [_vm._v("Supply Data Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-011"
    }
  }, [_vm._v("Demand")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-012"
    }
  }, [_vm._v("Demand Components")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-013"
    }
  }, [_vm._v("Demand Data Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-014"
    }
  }, [_vm._v("Storage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Transaction Types")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 - The Financial Natural Gas Market")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Value")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perceived vs. Market Value")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pricing and Trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 - Hedging and Trading Instruments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Financial Market Terminology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Futures")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indexes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swaps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basis Swaps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index Swaps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swing Swaps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EFPs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triggers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of Hedging and Trading Instruments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 - Structured Transactions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buying High and Selling Low for a Profit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hedging Firm Transportation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Physical Swing Options to Producers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Physical Swing Options to End-users")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Index Gas with a Cap to a Buyer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hedging and Trading Storage Capacity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buying Gas at a Floating Nearby Futures Price")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling Gas at a Floating Nearby Futures Price")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paying a Premium Over Market to a Supplier and Making a Profit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selling at a Discount to Market to a Buyer for a Profit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 - Building a Risk Management Model")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Centralized Risk Management")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fixed-Price Book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Index Book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Basis Book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transport Book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organization of Regional Desks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample Transaction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 - Natural Gas in the Electric Power Market")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electricity Market Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Characteristics of Electric Power Market Fundamentals")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Managing the Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 - The Liquefied Natural Gas (LNG) Market")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terms and Conversions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Market Fundamentals")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNG Trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_index"
  }, [_c('span', {
    attrs: {
      "href": "#/index1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0